module.exports = ".width30 {\n  width: 150px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/organisation-type-master/organisation-type-master.component.scss
// module id = ./src/app/component/organisation-type-master/organisation-type-master.component.scss
// module chunks = main